module.exports = __webpack_public_path__ + "img/flag-GB.1e0766b2.svg";